import { entityTypeNames } from '@tunasong/schemas'
import * as z from 'zod'

const eventTypes = [
  'general',
  'share',
  'invite',
  'poll-result',
  'poll-invite',
  /** Someone without access asked the owner for it (request-access spec §7.3) */
  'access-request',
  /** A venue sent its answers to a rider (Rider Phase 3b); the venue isn't a user, so there is no `from` (GH #2596) */
  'rider-answers',
  'comment',
  /** Someone liked your comment: its author only, never e-mailed (GH #2796) */
  'like',
  'redux-push',
  'user-starter-content',
  'delete-user',
  'delete-user-permanently',
  // AI / LLM events
  'mention',
  'generate-image',
  'generate-music',
  'agent-change-trigger',
  'cover-song',
  /** A band event was added, moved or cancelled (GH #2814 M2, spec N1 and N2) */
  'calendar',
] as const

export type ServerEventType = (typeof eventTypes)[number]

/** Server Events, typically triggered from changes in the entities */

export const ServerEventSchema = z.object({
  type: z.enum(eventTypes),
  entity: z.object({
    id: z.string(),
    parentId: z.string().optional(),
    name: z.string().optional(),
    type: z.enum(entityTypeNames),
  }),
  actions: z
    .array(
      z.object({
        title: z.string(),
        action: z.string(),
      })
    )
    .optional(),
  payload: z.record(z.string(), z.any()).optional(),
})
export type ServerEventInternal = z.infer<typeof ServerEventSchema>

export type ServerEvent<T = Record<string, unknown>> = ServerEventInternal & {
  payload?: T
}

export interface NotificationServerEvent extends ServerEvent, NotificationOptions {
  title?: string
  message: string
  /** Alert again when a notification replaces one with the same `tag` (GH #2795: one per comment thread) */
  renotify?: boolean

  /** Principal who have sent the notification. System message if not set */
  from?: string

  /** Principal ID to receive the message */
  to: string
}
